// This File Contains all the MUI Components Styled with custom Theme

import React from 'react';
import {
    Tabs as MuiTabs,
    Tab as MuiTab,
    Accordion as MuiAccordion,
    AccordionSummary as MuiAccordionSummary,
    AccordionDetails as MuiAccordionDetails,
    CircularProgress,
    Box
} from '@mui/material';
import { withStyles } from '@mui/styles';


export const Tabs = withStyles({
    root: {
        minHeight: '35px',
    },
    indicator: {
        left: '0px',
        height: '3px'
    }
})(MuiTabs);

export const Tab = withStyles({
    root: {
        background: "#dae3f3",
        marginRight: '5px',
        outline: '0px !important',
        minHeight: '35px',
    },
    wrapper: {
        fontWeight: 'bold',
    },
    selected: {
        background: "white",
    }
})(MuiTab);

export const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        flex: 0,
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
            flex: 1,
            width: '100%'
        },
    },
    expanded: {},
})(MuiAccordion);

export const AccordionSummary = withStyles({
    root: {
        backgroundColor: '#7395d3',
        color: 'white',
        fontWeight: 600,
        minHeight: 40,
        '&$expanded': {
            minHeight: 40,
        },
        margin: '0px 0'
    },
    content: {
        margin: '0px 0',
        '&$expanded': {
            margin: '0px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

export const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);

export const LoadingIndicator = () => (
    <Box
        sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.55)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1300,
        }}
    >
        <CircularProgress sx={{ color: '#fff' }} />
    </Box>
);